<template>
    <v-container fluid>
        <!-- <v-layout row>
            <v-flex md3>
                    <v-select
                        :items="getFirms"
                        label="Select Firm"
                        v-model="selectFirm"
                        outlined
                        clearable
                    ></v-select>
            </v-flex>
        </v-layout> -->
        <v-layout row align="center">
            <v-flex class="d-flex" cols="24" sm="24">
                <v-data-iterator
                :items="processedItems"
                content-tag="v-layout"  
                hide-actions > 
                <template slot="item" slot-scope="props">
                    <v-flex xs12 sm6 md4>
                    <v-card>
                        <v-card-title class="primary white--text"><h2>{{ props.item.name }}</h2></v-card-title>
                        <v-divider></v-divider>

                        <v-list dense>
                        <v-list-tile v-for="item in props.item.values" :key="item.key">
                            <v-list-tile-content><h2>{{item.key}}:</h2></v-list-tile-content>
                            <v-list-tile-content class="align-end"><h2>{{item.value}}</h2></v-list-tile-content>
                        </v-list-tile>
                        </v-list>
                    </v-card>
                    </v-flex>
                </template>
                </v-data-iterator>
            </v-flex>
        </v-layout>
    </v-container>    
</template>

<script>
    import { createNamespacedHelpers } from 'vuex'
    const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
    import * as d3 from 'd3'
    export default {
        name: 'items',
        data: () => ({
            firms: [],
            items: [],
            selectFirm: null
        }),
        created () {
            // this.$bindAsArray(
            //     'items',
            //     this.$root.$firebaseRefs.item
            // )
            this.$bindAsArray(
                'firms',
                this.$root.$firebaseRefs.firm
            )
        },
        computed: {
            ...mapGlobalGetters(['selectedBrand']),
            getFirms () {
                if (this.firms && this.selectedBrand) {
                    return this.firms
                        .filter(item => item['brand'] === this.selectedBrand)
                        .map(item => ({text: item.name, value: item['.key']}))
                }
            },
            processedItems () {
                if (this.items.length) {
                    let filteredItems = this.items
                    .filter((item) => {
                        return item['brand'] === this.selectedBrand && item['status'] !== 'closed'
                    })
                    .filter(({firm}) => this.selectFirm ? this.selectFirm == firm : true)
                    ;
                    let data = d3.nest()
                        .key((d) => { return d.type; })
                        .key((d) => { return d.subType; })
                        .rollup((v) => { return d3.sum(v, (d) => { return d.quantity; }); })
                    .entries(filteredItems);

                    data = data
                    .filter(({key}) => (key && key.trim() != ""))
                        .map(({key, values}) => ({
                            name: key, values: values
                                .filter(({key}) => (key && key.trim() != ""))
                                // .map(({key, value}) => ({[key]: value}))
                        }))
                    // console.log('med', JSON.stringify(data));
                    // data = data.map(({name, values})=> {
                    //     let result = {
                    //         name
                    //     }
                    //     values.forEach(value => {
                    //         result = {...result, ...value}
                    //     })
                    //     return result
                    // })
                    console.log('final', JSON.stringify(data));
                    
                    return data
                }
                return []
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Items/index.vue